export const buttonPrimary = "btn-primary";
export const buttonSecondary = "btn-secondary";
export const spinner = "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"
export const label = "block text-sm font-medium text-gray-700 mb-1";
export const textBox = "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500";
export const validationError = "text-red-700";
export const inlineIcon = "w-4 h-4 mt-auto mb-auto"